var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login-page"},[_c('div',{staticClass:"login-page-container"},[_c('LoginStep',{attrs:{"redirect-url":_vm.redirectUrll}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }